<page-title [title]="title"></page-title>
<p>Consulte e gerencie seus planos de saúde:</p>

<page-alert message="Plano de Sáude salvo com sucesso!" *ngIf="submittedSettings && successSettings" alertClass="alert-success"></page-alert>
<page-alert message="Falha ao salvar plano de Sáude!" *ngIf="submittedSettings && !successSettings" alertClass="alert-danger"></page-alert>

<mat-card class="plan-selection-card">
  <h2>Escolha os Planos de Saúde e Convênios</h2>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div formArrayName="healthPlans">

      <!-- Iterar sobre os planos de saúde -->
      <div *ngFor="let plan of getHealthPlansFormArray().controls; let i = index" [formGroupName]="i">
        <mat-card class="plan-card">
          <!-- Checkbox para o plano de saúde -->
          <mat-checkbox formControlName="accepted">{{ plan.get('name')?.value }}</mat-checkbox>

          <!-- Iterar sobre os convênios dentro do plano -->
          <div formArrayName="agreements" class="agreements-list">
            <div *ngFor="let agreement of getAgreementsFormArray(i).controls; let j = index" [formGroupName]="j">
              <!-- Checkbox para cada convênio (subcategoria) -->
              <mat-checkbox formControlName="accepted">{{ agreement.get('name')?.value }}</mat-checkbox>
            </div>
          </div>
        </mat-card>
      </div>

    </div>

    <button (click)="createOrUpdate()" mat-raised-button color="primary" type="submit">Salvar</button>
  </form>

</mat-card>
